import React from "react";
import DataSuccess from "./DataSuccess.js";
import MessageBox from "../../Reusable/MessageBox/MessageBox.js";
import LoadingImageElement from "components/Elements/LoadingContainerElement/LoadingImageElement.tsx";
import { useMail } from "../../../contexts/mailContext/mailContext.js";

import "./GridHolder.scss";

const GridHolder = () => {
  const { getAlertToUser, getFilesLoading, getFilesList, getPageNumber } =
    useMail();

  return (
    <div className="grid-container">
      {getAlertToUser()
        ? Object.keys(getAlertToUser()).map((i) => {
            return (
              <MessageBox
                key={i}
                textKey={getAlertToUser()[i].text}
                icon={{
                  name: getAlertToUser()[i].icon,
                  color: getAlertToUser()[i].color,
                }}
                replaceText={getAlertToUser()[i].dangerousExtentions}
                allowClosing={getAlertToUser()[i].allowClosing}
              />
            );
          })
        : null}
      {getFilesLoading() &&
      (getFilesList()?.length === 0 || getPageNumber() === 1) ? (
        <div className="pagination-loader">
          <LoadingImageElement />
        </div>
      ) : (
        <DataSuccess />
      )}
    </div>
  );
};

export default GridHolder;
